// extracted by mini-css-extract-plugin
module.exports = {"compactPage":"style_compactPage__FtDaX"};